import { Component } from "react";

interface Props {
  priceAlert: any;
  label: string;
  isMobile?: boolean;
  matchedVendors?: any[];
}
class PriceAlertStatus extends Component<Props, {}> {
  // Find all vendors with prices below or equal to the alert price
  findAllMatchingVendors = (itemPricing: any[], alertPrice: number) => {
    if (!itemPricing || !itemPricing.length) return { matchedVendors: [] };
    
    // Find all vendors that have a price at or below the alert price
    const matchedVendors = itemPricing
      .filter(pricing => pricing.price <= alertPrice)
      .map(pricing => ({
        vendorId: pricing.vendor_id,
        vendor: pricing.vendor_id === 1 ? "Woolworths" : "Coles",
        price: pricing.price
      }));
    
    return { matchedVendors };
  };
  
  render() {
    const { is_active } = this.props.priceAlert;
    // Access is_triggered property safely
    const is_triggered = this.props.priceAlert?.is_triggered || false;
    const { label, isMobile, matchedVendors = [] } = this.props;
    
    return (
      <div>
        {is_triggered && matchedVendors.length > 0 && (
          <div style={{
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
            marginBottom: '10px',
            backgroundColor: 'white'
          }}>
            {/* Header bar */}
            <div style={{
              padding: '12px 14px',
              backgroundColor: '#f9f9f9',
              borderBottom: '1px solid #eee',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              {/* Product title removed from here to avoid duplication */}
              {/* Removed price dropped badge from here */}
              <div style={{ flex: 1 }}></div>
            </div>
            
            {/* Content area */}
            <div style={{
              padding: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: 'white'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flex: 1
              }}>
                <div style={{
                  backgroundColor: '#9300DA',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '500',
                  padding: '4px 10px',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <span style={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    marginRight: '5px'
                  }}></span>
                  Price dropped
                </div>
              </div>
              
              {/* Vendor pricing */}
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'flex-end'
              }}>
                {matchedVendors.map(vendor => (
                  <div key={vendor.vendorId} style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '8px',
                    padding: '5px 10px',
                    backgroundColor: vendor.vendorId === 1 ? 'rgba(255, 0, 0, 0.08)' : 'rgba(130, 185, 49, 0.08)',
                    borderRadius: '6px'
                  }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '4px',
                      backgroundColor: vendor.vendorId === 1 ? '#ff0000' : '#82b931',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: '600',
                      marginRight: '6px',
                      fontSize: '11px'
                    }}>
                      {vendor.vendorId === 1 ? 'C' : 'W'}
                    </div>
                    <span style={{fontWeight: '600', fontSize: '13px'}}>
                      ${vendor.price.toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {is_active && !is_triggered && (
          <div className="u-background--pink u-color-white u-pv--8 u-ph--20 u-main-font--vsmall u-br--bottom--small">
            {label}
          </div>
        )}
      </div>
    );
  }
}

export default PriceAlertStatus;
